export var LogLevel;
(function (LogLevel) {
    LogLevel["info"] = "info";
    LogLevel["log"] = "log";
    LogLevel["warning"] = "warning";
    LogLevel["error"] = "error";
})(LogLevel || (LogLevel = {}));
export class LogEntry {
    id;
    message = null;
    category = null;
    companyId = null;
    level = LogLevel.log;
    date;
    constructor(id, date, message, level = LogLevel.log, companyId = null, category = null) {
        this.id = id;
        this.message = message;
        this.level = level;
        this.companyId = companyId;
        this.date = date;
        this.category = category;
    }
}
